import { saveUserToken } from './store/actions';

function getToken() {
  return localStorage.getItem('japan-concierge-user-token');
}

export function setToken(token) {
  localStorage.setItem('japan-concierge-user-token', token);
  localStorage.setItem('japan-concierge-user-token-saved-at', new Date());
}

function getTokenSavedAt() {
  return new Date(localStorage.getItem('japan-concierge-user-token-saved-at'));
}

function hasValidToken() {
  var fiveDaysAgo = new Date();
  fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5);
  return getTokenSavedAt() > fiveDaysAgo;
}

function insertUserControllerElement() {
  var element = document.createElement('div');
  element.setAttribute('data-jc-controller', 'user');
  document.body.appendChild(element);
}

export function loadUser(store) {
  if (hasValidToken()) {
    store.dispatch(saveUserToken(getToken()));
  } else if (document.body) {
    insertUserControllerElement();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      insertUserControllerElement();
    });
  }
}